module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container"
  }, [_c('datatable', {
    attrs: {
      "url": _vm.usersUrl,
      "columns": _vm.tColumns,
      "options": _vm.tOptions
    },
    on: {
      "checked": _vm.onChecked
    },
    scopedSlots: _vm._u([{
      key: "status",
      fn: function(props) {
        return [_c('button', {
          staticClass: "btn btn-sm",
          class: {
            'btn-info': props.row.status === _vm.UserStatus.ACTIVE, 'btn-danger': props.row.status === _vm.UserStatus.REVOKED
          }
        }, [_vm._v(_vm._s(_vm.$t('userAdministration.userStatuses.' + props.row.status)))])]
      }
    }])
  }), _vm._v(" "), (_vm.optionsVisible) ? _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-btn', {
    attrs: {
      "variant": "success",
      "disabled": _vm.load
    },
    on: {
      "click": function($event) {
        return _vm.revokeUsers()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('userAdministration.userRevoke')) + "\n        "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1) : _vm._e()], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-de78e382", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-de78e382","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","b-img":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/user-administration/user-management/UserManagement.vue
// module id = 808
// module chunks = 1